export enum TransactionExternalServiceEnum {
  NotApplicable = 0,
  Stripe = 1,
  Plaid = 2,
  Tabapay = 3,
  SVB = 4,
  Manual = 5,
  Signature = 6,
  // Dwolla = 7,
  Astra = 8,
  Other = 100,
}

export const TransactionExternalServiceNames = {
  [TransactionExternalServiceEnum.NotApplicable]: 'Not Applicable',
  [TransactionExternalServiceEnum.Stripe]: 'Stripe',
  [TransactionExternalServiceEnum.Plaid]: 'Plaid',
  [TransactionExternalServiceEnum.Tabapay]: 'Tongo',
  [TransactionExternalServiceEnum.SVB]: 'ACH Payment',
  [TransactionExternalServiceEnum.Manual]: 'Manual',
  [TransactionExternalServiceEnum.Signature]: 'Signature',
  // [TransactionExternalServiceEnum.Dwolla]: 'Dwolla',
  [TransactionExternalServiceEnum.Astra]: 'Astra',
  [TransactionExternalServiceEnum.Other]: 'Other',
};
